import { render, staticRenderFns } from "./CoCard.vue?vue&type=template&id=1375ff94&scoped=true&"
import script from "./CoCard.vue?vue&type=script&lang=ts&"
export * from "./CoCard.vue?vue&type=script&lang=ts&"
import style0 from "./CoCard.vue?vue&type=style&index=0&id=1375ff94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375ff94",
  null
  
)

export default component.exports